import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { ECommonCountries } from 'enums/commonCountries';

import { validateICO } from './icoValidation';
import { validateNID } from './nidValidation';

export const icoNidValidation = (getValueFrom?: string) => [
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getValueFrom
        ? ({ getFieldValue }: any) => ({
              validator(_rule: RuleObject, value: string) {
                  if (!getFieldValue(getValueFrom)) return Promise.resolve();
                  if (
                      getFieldValue(getValueFrom) === ECommonCountries.CZ ||
                      getFieldValue(getValueFrom) === ECommonCountries.SK
                  ) {
                      if (!value || validateICO(value) === 0) return Promise.resolve();
                      return Promise.reject(<TranslateText>NEVALIDNI_ICO</TranslateText>);
                  }
                  if (!value || validateNID(value) === 0) return Promise.resolve();
                  return Promise.reject(<TranslateText>CHYBNY_NID</TranslateText>);
              }
          })
        : () => ({
              validator(_rule: RuleObject, value: string) {
                  if (!value || validateICO(value) === 0 || validateNID(value) === 0) return Promise.resolve();
                  return Promise.reject(<TranslateText>INVALID_ICO_NID</TranslateText>);
              }
          })
];

export default icoNidValidation;
